module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/march-c76376781e304b3871870656d9693cf5.png";